import React, { CSSProperties, useMemo, useRef, useState } from 'react';
import { Select, Spin } from 'antd';
import debounce from 'lodash/debounce';
import './index.less';
import { SearchSvgComponent, SoilProfileDropDownIcon, SoilProfileExpandIcon } from '@/resource/IconComponentSets';
import { soilProfileGetPlaceNameByString } from '@/util/Request';
import { ISoilProfilePlaceGeoNames, ISoilProfilePlaceNameResModel } from '@/util/Request/requestType';
import IF from '../IF';


interface IProps {
    fetchoptions: (searchString: string) => Promise<ISoilProfilePlaceNameResModel>
    debounceTimeout?: number
    mode: 'multiple' | 'tags'
    value: any[]
    placeholder: string
    onChange: any
    style: CSSProperties
    visible?: boolean
    onclick?: (e:any) => void
}

interface IFieldNames {
    value?: string;
    label?: string;
    options?: string;
    record?: ISoilProfilePlaceGeoNames
}

const DebounceSelect = (props: IProps) => {
    const {
        fetchoptions,
        debounceTimeout,
        onChange,
        style,
        mode,
        value,
        placeholder,
        visible,
        onclick
    } = props;


    const [fetching, setFetching] = useState(false);
    const [options, setOptions] = useState<IFieldNames[]>();
    const fetchRef = useRef(0);
    const debounceFetcher = useMemo(() => {
        const loadOptions = (value) => {
            fetchRef.current += 1;
            const fetchId = fetchRef.current;
            setFetching(true);
            fetchoptions(value).then((newOptions) => {
                console.log('lanxue newOptions',newOptions);
                console.log('lanxue fetchId',fetchId);
                console.log('lanxue fetchRef.current',fetchRef.current);
                if (fetchId !== fetchRef.current) {
                    // for fetch callback order
                    return;
                }
                const newValues = newOptions?.geonames.map(item => {
                    return {
                        key: item.geonameId,
                        //dropdown need display:name,adminName1
                        value: `${item.name === null ? '' : item.name}${item.name === null ? '' : ','}${item.adminName1}`,
                        label: `${item.name === null ? '' : item.name}${item.name === null ? '' : ','}${item.adminName1}`,
                        record: item
                    };
                });
                console.log('lanxue newValues',newValues);
                setOptions(newValues);
                setFetching(false);
            });
        };

        return debounce(loadOptions, debounceTimeout);
    }, [fetchoptions, debounceTimeout]);

    return (
        <>
            <Select
                labelInValue={false}
                autoClearSearchValue={true}
                filterOption={false}
                onSearch={debounceFetcher}
                notFoundContent={fetching ? <Spin size="small" /> : null}
                mode={mode}
                placeholder={placeholder}
                style={style}
                value={value}
                options={options}
                autoFocus={true}
                onChange={(value, option) => {
                    console.log('value', value);
                    console.log('option', option);
                    onChange(value, option && option[0].record);
                }}
            />
        </>
    );
};

interface ISuperProps {
    selectCallback: ( select: string ,options: ISoilProfilePlaceGeoNames) => void
    selectedPlaceCount: number
}

const SoilDebounceSelectComponent = (props: ISuperProps) => {
    const [visible, setVisiblle] = useState(false);

    const fetchLocationPoints = async (searchString: string) => {
        return soilProfileGetPlaceNameByString(searchString);
    };

    const localRef = useRef(null);

    document.addEventListener('click',e => {
        if (!visible || !localRef) {
            return;
        }
        if(localRef && localRef.current && !localRef.current.contains(e.target)){
            setVisiblle(false);
        }
    });

    return (
        <div ref={localRef} className='select-input-container' onClick={() => setVisiblle(true)}>
            <label className='place-holder'>Type your location here</label>
            <div style={{ width: '100%',marginRight: '-20px' }}>
                <IF show={visible}>
                    {() => (
                        <DebounceSelect
                            mode="multiple"
                            value={[]}
                            placeholder={''}
                            fetchoptions={fetchLocationPoints}
                            onChange={(select, options) => {
                                setVisiblle(false);
                                props.selectCallback(select, options);
                            }}
                            style={{
                                width: '100%',
                                zIndex: '200',
                                background: '#F3F4F6'
                            }}
                            debounceTimeout={500}
                        />
                    )}
                </IF>
            </div>
            {visible ? <SoilProfileExpandIcon className='drop-down-icon' /> : <SoilProfileDropDownIcon className='drop-down-icon' />}
        </div>
    );
};

export default SoilDebounceSelectComponent;